// src/plugins/i18n.ts
import { createI18n } from 'vue-i18n'
import ptBR from '@/locales/pt.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'

export type SupportedLocale = 'pt-BR' | 'en' | 'es'

export function pickSupportedLocale(input: unknown): SupportedLocale {
  if (typeof input === 'string') {
    const s = input.toLowerCase()
    if (s.startsWith('pt')) return 'pt-BR'
    if (s.startsWith('en')) return 'en'
    if (s.startsWith('es')) return 'es'
  }
  return 'pt-BR'
}

export const i18n = createI18n({
  legacy: false,
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    en,
    es, // ✅ importante
  },
  missingWarn: false,
  fallbackWarn: false,
})
